import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LatLngLiteral } from 'leaflet';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangeDrawOptions, Geozone, GeozoneTypeEnum } from '../types/geozoneTypes';
import {
  DrawOverSpeedsForTrack,
  DrawParkingsForTrack,
  DrawPlumsForTrack,
  DrawRefuelsForTrack,
  DrawStopsForTrack,
} from '../types/track-event';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  private readonly httpClient = inject(HttpClient);

  public selectedObjects: any = new BehaviorSubject([]);
  public drawMapObjects = new BehaviorSubject([]);

  public updateTrackObjectPoint = new Subject();
  public panTo = new Subject<LatLngLiteral>();
  public setDrawMode = new Subject<boolean>();
  public changeDrawOptions = new Subject<ChangeDrawOptions>();
  public clearMapGeozone = new Subject();
  public changeObjectMarkerPos = new Subject();
  public editGeozone = new Subject<Geozone<GeozoneTypeEnum> | null>();
  public duplicateGeozone = new Subject<Geozone<GeozoneTypeEnum> | null>();

  public showStartTrack = new Subject();
  public showFinishTrack = new Subject();
  public drawStopsForTrack = new Subject<DrawStopsForTrack>();
  public drawParkingsForTrack = new Subject<DrawParkingsForTrack>();
  public drawRefuelsForTrack = new Subject<DrawRefuelsForTrack>();
  public drawPlumsForTrack = new Subject<DrawPlumsForTrack>();
  public drawOverSpeedForTrack = new Subject<DrawOverSpeedsForTrack>();
  public drawStartEndsForTrack = new Subject();
  public highlightTrip = new Subject<{ start: string; end: string }>();

  public zoomOnMap = new Subject();
  public deviceZoomOnMap = new Subject<number>();
  public zoomBuildingOnMap = new Subject<LatLngLiteral>();

  getAddressByCoordinates(lat: number, lng: number) {
    return this.httpClient
      .post('geocoding/reverse/', {
        coordinates: [{ lat, lng }],
      })
      .pipe(
        map((res: any) => {
          const key = Object.keys(res)[0];
          return res[key].address;
        }),
      );
  }

  getAddress(coordinates: any) {
    return this.httpClient.post('geocoding/reverse/', {
      coordinates,
    });
  }
}
